import { getApp, getApps, initializeApp } from 'firebase/app';

export const firebaseConfig = {
  apiKey: 'AIzaSyBTKmZMdCXDTprjusHshdoBzhF_hA0viVI',
  authDomain: 'pixiesound-2b380.firebaseapp.com',
  projectId: 'pixiesound-2b380',
  storageBucket: 'pixiesound-2b380.firebasestorage.app',
  messagingSenderId: '288175484811',
  appId: '1:288175484811:web:1d08432c824677667c498e',
  measurementId: 'G-WB2JNH9JVN',
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
